import { render, staticRenderFns } from "./BorrarBase.vue?vue&type=template&id=10561757"
import script from "./BorrarBase.vue?vue&type=script&lang=js"
export * from "./BorrarBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports